import React, { memo, useCallback } from "react";
import { Icon } from "uikit";
import { useHistory } from "react-router-dom";
import styled from "styled-components";

import { useTypedDispatch } from "../../../../../../redux/store";
import Session from "../../../../../../redux/services/Session";
import { ROUTES } from "../../../../../../constants/routes";
import { sipDisconnect } from "../../../../../../utils/jsSip";

const Root = styled.div`
	padding-inline: 12px;

	font-family: Lato;
	font-size: 13px;
	font-weight: 600;
	line-height: 16px;
	letter-spacing: 0em;
	text-align: center;

	color: #bcc1c5;

	cursor: pointer;

	user-select: none;
`;

const Logout = memo(() => {
	const dispatch = useTypedDispatch();
	const history = useHistory();

	const logout = useCallback(async () => {
		await sipDisconnect();
		history.push(ROUTES.LOGIN);
		dispatch(Session.logout());
	}, [dispatch, history]);

	return (
		<Root>
			<div onClick={logout}>
				<Icon id="headerLogout" size={24} colors={["#bcc1c5"]} />
			</div>
		</Root>
	);
});

export default Logout;
